export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14301.a2f2160b.jpg";